import type { TrendValue } from "@/components/ui/trend";

export const getCalculateTrend = (trend: TrendValue) => {
  const isPositive = trend.valueForPeriod > trend.comparedToValue;
  const value = Math.abs(
    Math.round((trend.valueForPeriod / trend.comparedToValue - 1) * 100 * 10) /
      10
  );
  return { value, isPositive };
};
